<template>
  <div>
    <v-card :style="[
      $vuetify.breakpoint.smAndDown
        ? { 'min-height': '100vh', 'background-color': '#f9f9f9' }
        : { 'background-color': '#f9f9f9' },
    ]">
      <div>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <v-card variant="outlined">
                <v-card-title style="font-weight: bolder">
                  <v-row>
                    <v-col cols="12" md="3">Welcome back
                      <span class="ml-5" style="color: #22577a">{{
                        username
                      }}</span></v-col>
                    <v-col cols="12" md="6"><span class="ml-5">{{ CurrentDatetime }}</span></v-col>
                    <v-col cols="12" md="3" style="text-align: right"><span style="color: #e95c00">Carpark
                        Management</span></v-col>
                  </v-row>
                </v-card-title>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="9"></v-col>
            <v-col cols="12" md="3" style="text-align: right">
              <v-autocomplete :items="TowerList" label="Tower" item-text="towerName"
                @change="getTotalNumberDataDashboard('1')" item-value="towerID" v-model="Tower" outlined dense
                clearable></v-autocomplete>
            </v-col>
          </v-row>
          <v-row style="margin-top: 2%">
            <v-col cols="12" md="3" sm="6">
              <v-card class="mx-auto rounded-xl" elevation="6" max-width="320">
                <v-sheet
                  color="blue"
                  class="pa-3 text-center rounded-t-xl"
                  elevation="8"
                >
                  <div
                    style="font-size: 20px"
                    class="font-weight-bold d-flex justify-center align-center white--text"
                  >
                    Total Member Carpark
                    <v-icon class="ml-2" color="white"
                      >mdi-account-multiple</v-icon
                    >
                  </div>
                  <div class="text-h4 font-weight-bold white--text mt-1">
                    {{
                      AddCommasNumber(
                        (memberCarpark?.memberActive || 0) +
                          (memberCarpark?.memberNotActive || 0)
                      )
                    }}
                  </div>
                </v-sheet>
                <v-card-text class="pa-3">
                  <v-row dense>
                    <v-col cols="6" class="info-text d-flex justify-start">
                      Active:
                      <span class="font-bold blue--text ml-1">
                        {{ AddCommasNumber(memberCarpark?.memberActive || 0) }}
                      </span>
                    </v-col>
                    <v-col cols="6" class="info-text d-flex justify-end">
                      Not Active:
                      <span class="font-bold blue--text ml-1">
                        {{
                          AddCommasNumber(memberCarpark?.memberNotActive || 0)
                        }}
                      </span>
                    </v-col>
                  </v-row>

                  <v-progress-linear
                    striped
                    v-model="TotalMember"
                    color="blue"
                    height="14"
                    rounded
                    class="mt-4"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-card class="mx-auto rounded-xl" elevation="6" max-width="320">
                <v-sheet
                  color="#ffae1f"
                  class="pa-3 text-center rounded-t-xl"
                  elevation="8"
                >
                  <div
                    style="font-size: 20px"
                    class="font-weight-bold d-flex justify-center align-center white--text"
                  >
                    Parking Information Today
                    <v-icon class="ml-2" color="white"
                      >mdi-car-hatchback</v-icon
                    >
                  </div>
                  <div class="text-h4 font-weight-bold white--text mt-1">
                    {{ AddCommasNumber(parkingInformation?.total || 0) }}
                  </div>
                </v-sheet>
                <v-card-text class="pa-3">
                  <v-row dense justify="space-between">
                    <v-col cols="auto" class="info-text">
                      Car :
                      <span class="font-bold">
                        {{
                          AddCommasNumber(
                            (parkingInformation?.carIn || 0) +
                              (parkingInformation?.carOut || 0)
                          )
                        }}
                      </span>
                    </v-col>
                    <v-col cols="auto" class="info-text text-right">
                      Motorcycle :
                      <span class="font-bold">
                        {{
                          AddCommasNumber(
                            (parkingInformation?.motorcycleIn || 0) +
                              (parkingInformation?.motorcycleOut || 0)
                          )
                        }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-progress-linear
                    striped
                    v-model="TotalParkingInfo"
                    color="warning"
                    height="14"
                    rounded
                    class="my-4"
                  ></v-progress-linear>
                  <div class="section-title">Remaining</div>
                  <v-row dense justify="space-between">
                    <v-col cols="auto" class="info-text">
                      Car:
                      <span class="font-bold">
                        {{ AddCommasNumber(parkingInformation?.carIn || 0) }}
                      </span>
                    </v-col>
                    <v-col cols="auto" class="info-text text-right">
                      Motorcycle:
                      <span class="font-bold">
                        {{
                          AddCommasNumber(parkingInformation?.motorcycleIn || 0)
                        }}
                      </span>
                    </v-col>
                  </v-row>
                  <div class="section-title mt-3">Exited</div>
                  <v-row dense justify="space-between">
                    <v-col cols="auto" class="info-text">
                      Car:
                      <span class="font-bold">
                        {{ AddCommasNumber(parkingInformation?.carOut || 0) }}
                      </span>
                    </v-col>
                    <v-col cols="auto" class="info-text text-right">
                      Motorcycle:
                      <span class="font-bold">
                        {{
                          AddCommasNumber(
                            parkingInformation?.motorcycleOut || 0
                          )
                        }}
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-card class="mx-auto rounded-xl" elevation="6" max-width="320">
                <v-sheet
                  color="pink"
                  class="pa-3 text-center rounded-t-xl"
                  elevation="8"
                >
                  <div
                    style="font-size: 20px"
                    class="font-weight-bold d-flex justify-center align-center white--text"
                  >
                    Member Entry Today
                    <v-icon class="ml-2" color="white"
                      >mdi-account-multiple</v-icon
                    >
                  </div>
                  <div class="text-h4 font-weight-bold white--text mt-1">
                    {{ AddCommasNumber(existSummaryMember?.totalMember || 0) }}
                  </div>
                </v-sheet>
                <v-card-text class="pa-3">
                  <v-row dense>
                    <v-col cols="6" class="info-text d-flex justify-start">
                      Car:
                      <span class="font-bold pink--text ml-1">{{
                        AddCommasNumber(
                          (existSummaryMember?.memberExistCar || 0) +
                            (existSummaryMember?.memberNotExistCar || 0)
                        )
                      }}</span>
                    </v-col>
                    <v-col cols="6" class="info-text d-flex justify-end">
                      Motorcycle:
                      <span class="font-bold pink--text ml-1">{{
                        AddCommasNumber(
                          (existSummaryMember?.memberExistMotorcycle || 0) +
                            (existSummaryMember?.memberNotExistMotorcycle || 0)
                        )
                      }}</span>
                    </v-col>
                  </v-row>

                  <v-progress-linear
                    striped
                    v-model="Member"
                    color="pink"
                    height="14"
                    rounded
                    class="my-4"
                  ></v-progress-linear>

                  <div class="section-title">Remaining</div>
                  <v-row dense>
                    <v-col cols="6" class="info-text d-flex justify-start">
                      Car:
                      <span class="font-bold pink--text ml-1">{{
                        AddCommasNumber(existSummaryMember?.memberExistCar || 0)
                      }}</span>
                    </v-col>
                    <v-col cols="6" class="info-text d-flex justify-end">
                      Motorcycle:
                      <span class="font-bold pink--text ml-1">{{
                        AddCommasNumber(
                          existSummaryMember?.memberExistMotorcycle || 0
                        )
                      }}</span>
                    </v-col>
                  </v-row>

                  <div class="section-title mt-3">Exited</div>
                  <v-row dense>
                    <v-col cols="6" class="info-text d-flex justify-start">
                      Car:
                      <span class="font-bold pink--text ml-1">{{
                        AddCommasNumber(
                          existSummaryMember?.memberNotExistCar || 0
                        )
                      }}</span>
                    </v-col>
                    <v-col cols="6" class="info-text d-flex justify-end">
                      Motorcycle:
                      <span class="font-bold pink--text ml-1">{{
                        AddCommasNumber(
                          existSummaryMember?.memberNotExistMotorcycle || 0
                        )
                      }}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-card class="mx-auto rounded-xl" elevation="6" max-width="320">
                <v-sheet
                  color="green"
                  class="pa-3 text-center rounded-t-xl"
                  elevation="8"
                >
                  <div
                    style="font-size: 20px"
                    class="font-weight-bold d-flex justify-center align-center white--text"
                  >
                    Visitor Entry Today
                    <v-icon class="ml-2" color="white"
                      >mdi-briefcase-account</v-icon
                    >
                  </div>
                  <div class="text-h4 font-weight-bold white--text mt-1">
                    {{
                      AddCommasNumber(existSummaryVisitor?.totalVisitor || 0)
                    }}
                  </div>
                </v-sheet>
                <v-card-text class="pa-3">
                  <v-row dense>
                    <v-col cols="6" class="info-text d-flex justify-start">
                      Car:
                      <span class="font-bold green--text ml-1">{{
                        AddCommasNumber(
                          (existSummaryVisitor?.visitorExistCar || 0) +
                            (existSummaryVisitor?.visitorNotExistCar || 0)
                        )
                      }}</span>
                    </v-col>
                    <v-col cols="6" class="info-text d-flex justify-end">
                      Motorcycle:
                      <span class="font-bold green--text ml-1">{{
                        AddCommasNumber(
                          (existSummaryVisitor?.visitorExistMotorcycle || 0) +
                            (existSummaryVisitor?.visitorNotExistMotorcycle ||
                              0)
                        )
                      }}</span>
                    </v-col>
                  </v-row>

                  <v-progress-linear
                    striped
                    v-model="Visitor"
                    color="green"
                    height="14"
                    rounded
                    class="my-4"
                  ></v-progress-linear>

                  <div class="section-title">Remaining</div>
                  <v-row dense>
                    <v-col cols="6" class="info-text d-flex justify-start">
                      Car:
                      <span class="font-bold green--text ml-1">{{
                        AddCommasNumber(
                          existSummaryVisitor?.visitorExistCar || 0
                        )
                      }}</span>
                    </v-col>
                    <v-col cols="6" class="info-text d-flex justify-end">
                      Motorcycle:
                      <span class="font-bold green--text ml-1">{{
                        AddCommasNumber(
                          existSummaryVisitor?.visitorExistMotorcycle || 0
                        )
                      }}</span>
                    </v-col>
                  </v-row>

                  <div class="section-title mt-3">Exited</div>
                  <v-row dense>
                    <v-col cols="6" class="info-text d-flex justify-start">
                      Car:
                      <span class="font-bold green--text ml-1">{{
                        AddCommasNumber(
                          existSummaryVisitor?.visitorNotExistCar || 0
                        )
                      }}</span>
                    </v-col>
                    <v-col cols="6" class="info-text d-flex justify-end">
                      Motorcycle:
                      <span class="font-bold green--text ml-1">{{
                        AddCommasNumber(
                          existSummaryVisitor?.visitorNotExistMotorcycle || 0
                        )
                      }}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </div>

      <div>
        <v-row style="padding: 20px">
          <v-col cols="12" md="12" sm="12">
            <v-card class="mt-3 mx-auto">
              <v-sheet
                class="v-sheet--offset mx-auto"
                color="blue"
                elevation="12"
                max-width="calc(100% -  32px)"
                height="70"
              >
                <v-card-title class="text-h5" style="color: white">
                  Time Period Carpark
                </v-card-title>
              </v-sheet>
              <apexchart
                v-if="show"
                type="bar"
                height="500"
                :options="chartOptions"
                :series="series"
              ></apexchart>
            </v-card>
          </v-col>
        </v-row>
        <v-row style="padding: 20px" justify="center">
          <v-col cols="12" md="9" sm="9">
            <v-card class="mt-3 mx-auto">
              <v-sheet
                class="v-sheet--offset mx-auto"
                color="blue"
                elevation="12"
                max-width="calc(100% -  32px)"
                height="70"
              >
                <v-card-title class="text-h5" style="color: white">
                  Latest Entry Carpark : Past 7 Days
                </v-card-title>
              </v-sheet>
              <apexchart
                v-if="show"
                type="bar"
                height="500"
                :options="chartOptions2"
                :series="series2"
              ></apexchart>
            </v-card>
          </v-col>
        </v-row>
        <v-row style="padding: 20px" v-show="false">
          <v-col cols="12" md="12" sm="12">
            <v-card class="mt-3 mx-auto">
              <v-sheet
                class="v-sheet--offset mx-auto"
                color="blue"
                elevation="12"
                max-width="calc(100% - 32px)"
                height="70"
              >
                <v-card-title class="text-h5" style="color: white">
                  Parking Information
                </v-card-title>
              </v-sheet>
              <!-- <v-card-title> Latest Entry </v-card-title> -->
              <v-simple-table fixed-header height="300px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">No</th>
                      <th class="text-center">หมายเลขบัตร</th>
                      <th class="text-center">ทะเบียนรถ</th>
                      <th class="text-center">เวลาเข้า</th>
                      <th class="text-center">เวลาออก</th>
                      <th class="text-center">ประเภทรถ</th>
                      <th class="text-center">รหัสสมาขิก</th>
                      <th class="text-center">ตู้ทำรายการเข้า</th>
                      <th class="text-center">ตู้ทำรายการออก</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in DataList" :key="item.id">
                      <td class="text-center">
                        {{ index + 1 }}
                      </td>
                      <td class="text-center">{{ item.logEntry }}</td>
                      <td class="text-center">{{ item.carNo }}</td>
                      <td class="text-center">
                        {{ ChangeFormatDate(item.entryDate) }}
                      </td>
                      <td class="text-center">
                        {{ ChangeFormatDate(item.exitDate) }}
                      </td>
                      <td class="text-center">
                        {{ item.vehicleType == 0 ? "Car" : "Motorcycle" }}
                      </td>
                      <td class="text-center">
                        {{ item.ticketNo }}
                      </td>
                      <td class="text-center">
                        {{ ConvertTerminalID(item.terminalEntry) }}
                      </td>
                      <td class="text-center">
                        {{ ConvertTerminalID(item.terminalExit) }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <!-- <div class="mb-3">
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-card class="ml-4 mr-4" color="#5D87FF" dark>
              <v-card-title class="text-h5"> List </v-card-title>
              <v-card-subtitle>1234</v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </div> -->
    </v-card>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <div class="loading-box">
        <div class="inter-load">
          <div class="rect rect1"></div>
          <div class="rect rect2"></div>
          <div class="rect rect3"></div>
          <div class="rect rect4"></div>
          <div class="rect rect5"></div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { eventBus } from "../main";

export default {
  name: "DashboardCarpark",
  components: {},
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      dialog: false,
      show: false,
      items: [10, 15, 20, 50, 100],
      pageCount: 0,
      image: null,
      page: 1,
      itemsPerPage: 10,
      search: "",
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",
      memberCarpark: [],
      parkingInformation: [],
      existSummaryMember: [],
      existSummaryVisitor: [],

      existTower: [],
      existTowerEntry: [],
      existTowerExit: [],
      responseTime: [],
      responseDate: [],
      username: localStorage.getItem("Username"),
      TotalParkingInfo: 0,
      TotalMember: 0,
      Member: 0,
      Visitor: 0,
      dateNow: "",
      CurrentDatetime: "",
      ConfigTerminal: [],
      DataList: [],
      TowerList: [],
      Tower: null,

      labels1: ["12am", "3am", "6am", "9am", "12pm", "3pm", "6pm", "9pm"],
      value1: [200, 675, 410, 390, 310, 460, 250, 240],
      chartOptionsdonut: {
        labels: ["Apple", "Mango", "Orange", "Watermelon"],
      },
      seriesdonut: [44, 55, 41, 17, 15],
      timeCount: 15,
      series: [
        {
          name: "Entry",
          data: [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0,
          ],
        },
        {
          name: "Exit",
          data: [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0,
          ],
        },
      ],
      series2: [
        {
          name: "Entry",
          data: [0, 0, 0, 0, 0, 0, 0], //7
        },
        {
          name: "Exit",
          data: [0, 0, 0, 0, 0, 0, 0], //7
        },
      ],

      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
        },
        colors: ["#008000", "#FF0000"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          title: {
            text: "Time Period",
          },
          categories: [
            "00:00",
            "01:00",
            "02:00",
            "03:00",
            "04:00",
            "05:00",
            "06:00",
            "07:00",
            "08:00",
            "09:00",
            "10:00",
            "11:00",
            "12:00",
            "13:00",
            "14:00",
            "15:00",
            "16:00",
            "17:00",
            "18:00",
            "19:00",
            "20:00",
            "21:00",
            "22:00",
            "23:00",
          ],
        },
        yaxis: {
          title: {
            text: "Total",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " times";
            },
          },
        },
      },
      chartOptions2: {
        chart: {
          type: "bar",
          height: 350,
        },
        colors: ["#008000", "#FF0000"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          title: {
            text: "Datetime",
          },
          categories: [
            new Intl.DateTimeFormat("en-CA").format(
              new Date().setDate(new Date().getDate() - 6) // set date to initial when data = null
            ),
            new Intl.DateTimeFormat("en-CA").format(
              new Date().setDate(new Date().getDate() - 5)
            ),
            new Intl.DateTimeFormat("en-CA").format(
              new Date().setDate(new Date().getDate() - 4)
            ),
            new Intl.DateTimeFormat("en-CA").format(
              new Date().setDate(new Date().getDate() - 3)
            ),
            new Intl.DateTimeFormat("en-CA").format(
              new Date().setDate(new Date().getDate() - 2)
            ),
            new Intl.DateTimeFormat("en-CA").format(
              new Date().setDate(new Date().getDate() - 1)
            ),
            new Intl.DateTimeFormat("en-CA").format(
              new Date().setDate(new Date().getDate())
            ),
          ],
        },
        yaxis: {
          title: {
            text: "Total",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + " times";
            },
          },
        },
      },
    };
  },

  async mounted() {
    let that = this;
    that.dateNow = new Date();

    // that.LoadingDialog = true;
    await that.getTowerList();
    await that.getMasConfigTerminal();
    // await that.getDataTransactionCarpark();
    await that.getTotalNumberDataDashboard("1");

    // that.LoadingDialog = false;
    setInterval(() => {
      that.getCurrentDate();

      that.timeCount--;
      if(that.timeCount == 0){
        if(localStorage.getItem("page") == "Dashboard Carpark"){
          that.timeCount = 15;
          // console.log(localStorage.getItem("page"));
          that.getTotalNumberDataDashboard("2");
        }
      }
    }, 1000);


  },

  methods: {
    getTowerList() {
      let self = this;
      return axios
        .get(`${self.url}Tower/getTower`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.TowerList = response.data.data;
            if (self.TowerList.length > 0 && self.Tower == null) {
              self.Tower = self.TowerList[0].towerID;
            }
            // console.log(response.data.data);
            // self.getTotalNumberDataDashboard("1");
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    AddCommasNumber(x) {
      if (x != null) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },

    async getDataTransactionCarpark() {
      let self = this;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: 20,
        logEntry: null,
        carNo: null,
        entryDate: null,
        exitDate: null,
        vehicleType: null,
        ticketNo: null,
        terminalEntry: null,
        tenantID: null,
        statusLog: null,
      };
      await axios
        .post(`${self.url}TransactionCarpark/getDataTransactionCarpark`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.DataList = response.data.data.listData;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    refreshDashboard() {
      let that = this;
      var refresh = setInterval(() => {
        if (localStorage.getItem("page") == "Dashboard Carpark") {
          that.getTotalNumberDataDashboard("2");
          // that.getDataTransactionCarpark();
          // that.timeCount = 10;
        } else {
          clearInterval(refresh);
        }
      }, 10000);
    },

    getTotalNumberDataDashboard(data) {
      let that = this;
      if (data == "1") {
        that.LoadingDialog = true;
      }
      // console.log(data);
      let temp = {
        towerID: that.Tower
      };
      axios
        .post(`${that.url}Dashboard/getTotalDashboardCarpark`, temp)
        .then(function (response) {
          if (response.data.status == 0) {


            that.memberCarpark = response.data.data.memberCarpark;
            that.parkingInformation = response.data.data.parkingInformation;
            that.existSummaryMember = response.data.data.existSummaryMember;
            that.existSummaryVisitor = response.data.data.existSummaryVisitor;


            that.TotalParkingInfo =
              (that.parkingInformation.in /
                (that.parkingInformation.in + that.parkingInformation.out)) *
              100;
            that.TotalMember =
              (that.memberCarpark.memberActive /
                (that.memberCarpark.memberActive +
                  that.memberCarpark.memberNotActive)) *
              100;

            that.Visitor =
              (that.existSummaryVisitor.visitorExist /
                (that.existSummaryVisitor.visitorNotExist +
                  that.existSummaryVisitor.visitorExist)) *
              100;
            that.Member =
              (that.existSummaryMember.memberExist /
                (that.existSummaryMember.memberExist +
                  that.existSummaryMember.memberNotExist)) *
              100;



            if (isNaN(that.TotalParkingInfo)) {
              that.TotalParkingInfo = 0;
            }
            if (isNaN(that.TotalMember)) {
              that.TotalMember = 0;
            }
            if (isNaN(that.Visitor)) {
              that.Visitor = 0;
            }
            if (isNaN(that.Member)) {
              that.Member = 0;
            }

        

            if (response.data.data.responseTime.length > 0) {
              that.responseTime = response.data.data.responseTime;
              that.getPeriod(that.responseTime);
            }
            if (response.data.data.responseDate.length > 0) {
              that.responseDate = response.data.data.responseDate;
              that.getPeriodDate(that.responseDate);
            }

            // that.responseTime = response.data.data.responseTime;
            // that.responseDate = response.data.data.responseDate;

            // that.getPeriod(that.responseTime);
            // that.getPeriodDate(that.responseDate);

            if (response.data.data.responseTime.length == 0) {
              that.series = [
                {
                  name: "Entry",
                  data: Array(24).fill(0),
                },
                {
                  name: "Exit",
                  data: Array(24).fill(0),
                },
              ]; // clear data to initial
            }
            if (response.data.data.responseDate.length == 0) {
              that.series2 = [
                {
                  name: "Entry",
                  data: Array(7).fill(0),
                },
                {
                  name: "Exit",
                  data: Array(7).fill(0),
                },
              ]; // clear data to initial
            }


            // that.LoadingDialog = false;
            that.show = true;
            // if (data == "1") {
            //   that.refreshDashboard();
            // }
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          that.LoadingDialog = false;
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            that.LoadingDialog = false;
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
          // eventBus.$emit('logout');
        });
    },

    logout() {
      eventBus.$emit("logout");
    },

    getPeriod(data) {
      const self = this;
      const hours = Array.from({ length: 24 }, (_, i) =>
        i.toString().padStart(2, "0")
      );
      self.series = [
        {
          name: "Entry",
          data: Array(24).fill(0),
        },
        {
          name: "Exit",
          data: Array(24).fill(0),
        },
      ];
      hours.forEach((hour, index) => {
        const found = data.find((x) => x.hour === hour);
        self.series[0].data[index] = found ? found.entry : 0;
        self.series[1].data[index] = found ? found.exit : 0;
      });
    },

    getPeriodDate(data) {
      let that = this;
      // console.log(data);
      that.series2 = [
        {
          name: "Entry",
          data: Array(7).fill(0),
        },
        {
          name: "Exit",
          data: Array(7).fill(0),
        },
      ]; // clear data to initial
      let categories = [];

      data.forEach((value, index) => {
        let strDate = value.transactionDate.split("T")[0].replaceAll("-", "/");
        categories.push(strDate);
        that.series2[0].data[index] = value.entry;

        that.series2[1].data[index] = value.exit;
      });
      that.chartOptions2.xaxis.categories = categories;
      // series2
    },

    async getMasConfigTerminal() {
      let that = this;
      await axios
        .get(`${that.url}TransactionCarpark/getMasConfigTerminal`)
        .then(function (response) {
          if (response.data.status == 0) {
            that.ConfigTerminal = response.data.data;
            // console.log(response.data.data);
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          that.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    ConvertTerminalID(value) {
      let self = this;
      if (value != null) {
        return self.ConfigTerminal.filter((x) => x.terminalID == value) == null
          ? ""
          : self.ConfigTerminal.filter((x) => x.terminalID == value)[0] == null
            ? ""
            : self.ConfigTerminal.filter((x) => x.terminalID == value)[0]
              .terminalName;
      }
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
    ChangeFormatDateNotime(date) {
      if (!date) return null;
      var DateData = new Date(date);
      DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear();
    },

    getCurrentDate() {
      const now = new Date();
      const pad = (n) => n.toString().padStart(2, '0');
      const day = pad(now.getDate());
      const month = pad(now.getMonth() + 1);
      const year = now.getFullYear() < 2500 ? now.getFullYear() + 543 : now.getFullYear();
      const hours = pad(now.getHours());
      const minutes = pad(now.getMinutes());
      const seconds = pad(now.getSeconds());

      this.CurrentDatetime = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }
  },
};
</script>
<style scoped>
* >>> .v-data-table-header {
  /* background-color: #9AC5F4 !important; */
  background-color: black !important;
  color: #ffffff !important;
}

* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}

.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}

.validation-class {
  color: red;
  font-size: 12px;
}

.header-table-css {
  text-align: center;
  cursor: pointer;
}

*,
::before ::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: #555555;
}

.loading-box {
  width: 150px;
  height: 100px;
  border: 5px solid #f1f1f1;
  /* margin: 100px auto; */
  position: relative;
}

.inter-load {
  width: 100px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.rect {
  background: #f1f1f1;
  display: inline-block;
  height: 60px;
  width: 7px;
  margin: 0 1px;
  animation: load 1.3s infinite ease-in-out;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }

  20% {
    transform: scaleY(1);
  }

  40% {
    transform: scaleY(0.4);
  }

  100% {
    transform: scaleY(0.4);
  }
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

.rect2 {
  animation-delay: -1.2s;
}

.rect3 {
  animation-delay: -1.1s;
}

.rect4 {
  animation-delay: -1s;
}

.rect5 {
  animation-delay: -0.9s;
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #888;
}

.info-text {
  font-size: 18px;
  color: #444;
}

.font-bold {
  font-weight: 600;
  color: #ffae1f;
}
</style>
